import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"
import { useMemo } from "react"
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table"
import { Table, Row, Col, Card, CardBody, Form, Label, Input } from "reactstrap"
import Loader from "pages/Separate/Loader"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import NewPagination from "components/Common/Newpagination"
import "../../../../assets/css/Work/support.css"
import secureLocalStorage from "react-secure-storage"
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"
import { codeReviewColumn } from "utils/columns/Support/developerTicketColumns"
import Swal from "sweetalert2"
import Select from "react-select"
import NoTickets from "../../../../assets/images/Inventory/warningImg.jpg"
import { useTimer } from "pages/WorkModule/Projects/Project Timer/TimerContext"

function TableContainer({ columns, data, setData, allData }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    previousPage,
    nextPage,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state
  useEffect(() => setPageSize(50), [])
  const [isLoading, setLoading] = useState(false)
  const [status, setStatus] = useState("open")

  return (
    <div>
      {isLoading && <Loader />}
      <div id="support-header" className="mb-4 align-items-center row">
        <div className="pr-0 support-status-part general-status-part col-md-10">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-start w-100 text-center align-items-center gap-3">
              <a
                className={`text-green pt-2 px-0 rounded work-status general-task-status ${
                  status == "open" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("open")
                  setData(allData?.filter(obj => obj?.dev_status == "open"))
                }}
              >
                <h4>
                  {allData?.filter(obj => obj?.dev_status == "open")?.length}
                </h4>
                <h4>Open</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "fixed" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("fixed")
                  setData(allData?.filter(obj => obj?.status == "fixed"))
                }}
              >
                <h4>
                  {allData?.filter(obj => obj?.status == "fixed")?.length}
                </h4>
                <h4>Fixed</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status  ${
                  status == "verify" ? "activeProjectTab" : ""
                }`}
                style={{ width: "20%" }}
                onClick={() => {
                  setStatus("verify")
                  setData(
                    allData?.filter(obj => obj?.dev_status == "ready_to_verify")
                  )
                }}
              >
                <h4>
                  {
                    allData?.filter(obj => obj?.dev_status == "ready_to_verify")
                      ?.length
                  }
                </h4>
                <h4>Ready to Verify</h4>
              </a>
              <a
                className={`text-green pt-2 px-2 rounded work-status general-task-status ${
                  status == "query" ? "activeProjectTab" : ""
                }`}
                onClick={() => {
                  setStatus("query")
                  setData(allData?.filter(obj => obj?.dev_status == "query"))
                }}
              >
                <h4>
                  {allData?.filter(obj => obj?.dev_status == "query")?.length}
                </h4>
                <h4>Queries</h4>
              </a>
            </div>
          </div>
        </div>
      </div>
      <Row>
        <div className="col-md-12 my-4 d-flex">
          <div className="col-md-6 d-flex justify-content-start align-items-center">
            <div className="col-md-2 d-flex justify-content-start align-items-center">
              <select
                className="s me-4 form-select"
                style={{ width: "100px" }}
                value={pageSize}
                onChange={e => setPageSize(e.target.value)}
              >
                {[10, 25, 50, 100].map(pageSize => (
                  <option key={pageSize} value={pageSize}>
                    Show {pageSize}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-6 d-flex justify-content-end align-items-center">
            <div className="search-box">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="s form-control rounded "
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </div>
      </Row>

      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className
                  return (
                    <th
                      key={index}
                      className={`col-t-${index + 1} ${classNames} ${
                        index != 0 && "customShortIcon"
                      }`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div>
                        {column.render("Header")}
                        {column.isShortIcon ? (
                          <span
                            style={{
                              display: index == 0 ? "none" : "block",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${
                                column.isSorted && !column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${
                                column.isSorted && column.isSortedDesc
                                  ? "text-dark"
                                  : ""
                              }`}
                            ></i>
                          </span>
                        ) : null}
                      </div>
                    </th>
                  )
                })}
              </tr>
            ))}
          </thead>
          <tbody className="fix-support-table-body" {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row)
              let backgroundStyle = {}
              const priority = row.original.priority_col

              return (
                <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                  {row.cells.map((cell, index) => (
                    <td
                      key={index}
                      className={`t-col-${index + 1} ${cell.column.className} ${
                        priority == "High" ? "highPriority" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <NewPagination
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          page={page}
          data={data}
          nextPage={nextPage}
        />
      </Row>
    </div>
  )
}

const CodeReview = ({ projectOption }) => {
  const [replyTiket, setReplyTiket] = useState(false)
  const [viewTicketHistory, setViewTicketHistory] = useState(false)
  const [editTask, setEditTask] = useState(false)
  const [replyWidth, setReplyWidth] = useState(0)
  const [data, setData] = useState([])
  const [allData, setAllData] = useState([])
  const token = secureLocalStorage.getItem("auth_token")
  const [projectId, setProjectId] = useState([])
  const [filterProject, setFilterProject] = useState(false)
  const toggleLoading = loading => {
    setLoading(loading)
  }

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") {
      if (replyTiket) {
        setReplyTiket(false)
      }
      if (viewTicketHistory) {
        setViewTicketHistory(false)
      }
      if (editTask) {
        setEditTask(false)
      }
    }
  })

  document.title = "Support | Zithas Technologies"
  const [isLoading, setLoading] = useState(false)
  const toogleLoading = loading => {
    setLoading(loading)
  }
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth
      setReplyWidth(viewportWidth * 0.98)
    }
    updateWidth()
    window.addEventListener("resize", updateWidth)
    return () => window.removeEventListener("resize", updateWidth)
  }, [])

  const [modal_Access, setAccessDenied] = useState(false)

  const onChangeStatus = (id, status) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure ?",
      text: `${
        status == "fixed"
          ? "You have fixed this code ?"
          : "You want to send for Query"
      } `,
      showCancelButton: true,
      confirmButtonText: "Yes! Done",
    }).then(async data => {
      if (data?.isConfirmed) {
        const res = await FetchNodePostData(
          toggleLoading,
          `codeReviewStatus/${id}/${status}`,
          token,
          {}
        )
        if (res?.data?.status) {
          Swal.fire({
            icon: "success",
            text: `${
              status == "fixed"
                ? "Code Fixed Successfully"
                : "Queries Send Successfully"
            }`,
          }).then(data => {
            setData(res?.data?.data?.filter((obj) => obj?.status == "open"))
            setAllData(res?.data?.data)
          })
        }
      }
    })
  }
  const { handleStartStop, isRunning, currentTaskId } = useTimer()
  const onStartTimer = async (obj) => {
    const date = new Date()
    const formEntriesStart = {
      user_id: localStorage.getItem("auth_id"),
      task_id: obj?.id,
      type: 0
    }
    const formEntiesStop = {
      id: localStorage.getItem("timerId"),
    }

    const res = await FetchNodePostData(
      toogleLoading,
      isRunning ? "codeReviewTimer/stopTimer" : "codeReviewTimer/startTimer",
      token,
      isRunning ? formEntiesStop : formEntriesStart
    )
    if (res?.data?.status) {
      if (!isRunning) {
        localStorage.setItem("task_id", obj.id)
        localStorage.setItem("timerId", res?.data?.data?.id)
        localStorage.setItem("start_time", date.toISOString())
        localStorage.setItem("code_time", true)
      } else {
        localStorage.removeItem("code_time")
      }
      handleStartStop(obj.id)
    } else {
      // Swal.fire({
      //   title: "⏱️ Timer already rockin'!",
      //   text: "Oops! Another timer is on the loose. Should we chase it down and turn off the existing one instead? 🚀😎",
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: "Yes, Stop Timers! 🔥",
      //   cancelButtonText: "Nah, let it roll! 😜",
      // }).then(async confirm => {
      //   if (confirm.isConfirmed) {
      //     const requestData = {
      //       ...formEntries,
      //       end_time: moment(date).format("YYYY-MM-DD HH:mm:ss"),
      //       type: 2,
      //       timer_id: res?.data?.message,
      //     }
      //     const response = await FetchPostData(
      //       toogleLoading,
      //       "startStopTaskTimer",
      //       token,
      //       requestData
      //     )
      //     if (response?.data?.success) {
      //       localStorage.removeItem("task_id")
      //       localStorage.removeItem("timerId")
      //       localStorage.removeItem("start_time")
      //       Swal.fire({
      //         icon: "success",
      //         title: "Timer Turned Off Successfully!",
      //       })
      //     }
      //   }
      // })
    }
  }
  const columns1 = useMemo(
    () => codeReviewColumn(onChangeStatus, onStartTimer, isRunning, currentTaskId),
    [isRunning]
  )

  const fetchProjects = async () => {
    const res = await fetchNodeData(toggleLoading, `listReview/${projectId?.value}`, token)
    if (res) {
      setFilterProject(true)
      setData(res?.filter(obj => obj?.dev_status == "open"))
      setAllData(res)
    }
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="row justify-content-between  align-items-center">
        <div className="col-md-3">
          <h5 className="text-purple mb-0 ms-3"> Code Review List</h5>
        </div>
        <div className="col-md-8">
          <div className="row justify-content-end  align-items-center">
            <div className="col-md-5">
              <Select
                placeholder="Select Project"
                className="basic-multi-select"
                classNamePrefix=" select"
                options={projectOption}
                value={projectId}
                onChange={e => setProjectId(e)}
              />
            </div>
            <div className="ms-2 col-md-1">
              <a
                className="btn btn-sm  me-1 bg-purple text-white"
                style={{ borderRadius: "5px" }}
                onClick={() => fetchProjects()}
              >
                <i className="bi bi-funnel-fill fs-5"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      {filterProject ? (
        <Container fluid>
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns1}
                      data={data}
                      allData={allData}
                      setAccessDenied={setAccessDenied}
                      setData={setData}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <img src={NoTickets} alt="No Img" width={300} />
          <h5 className="text-purple fw-bold  lh-lg text-center">
            Filter the projects, Sharpen your eyes, it's review time! 👀🧠{" "}
            <br />
            Let's polish that code and push quality to the next level! 💡✨
          </h5>
        </div>
      )}

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default CodeReview
